export default "/048cb1f2b29308e18768c65cfd51e426596a830c/865622b54fec272e12245ed26e84af24.png";